
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/screening",
      function () {
        return require("private-next-pages/screening/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/screening"])
      });
    }
  